import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * A text link between the auth forms ("Already registered? Click here...").
 *
 * It hands on RequireAuth's `from`, so moving between sign-in and sign-up still
 * lands the reader where they were going. The sign-up form's link used to drop
 * it: a reader who tapped "Offer a trade" on a shared trade list, went to
 * sign-up, then back to sign-in, ended on the map (JRN-1,
 * docs/PUBLIC_TRADE_LIST.md).
 */
const FormLink = ({ text, to, breakPoints }) => {
  const navigate = useNavigate();
  const from = useLocation().state?.from;
  return (
    <Grid item xs={12} {...breakPoints}>
      <Button variant="text" onClick={() => (from ? navigate(to, { state: { from } }) : navigate(to))}>
        <Typography variant="body2">
          {text}
          <Typography component="span" variant="subtitle2">
            {" "}
            Click here...
          </Typography>
        </Typography>
      </Button>
    </Grid>
  );
};

export default FormLink;
